import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import * as React from 'react';
import { AssetScreen } from 'screens/AssetScreen/AssetScreen';
import { AssetsScreen } from 'screens/AssetsScreen/AssetsScreen';
import { SyncIndicator } from 'screens/SyncScreen/SyncIndicator';

const Stack = createNativeStackNavigator<NavigationStacks[Stacks.OFFLINE]>();

export const TabOfflineScreen: React.FC = () => {
  return (
    <>
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
        }}
        initialRouteName={Screens.OFFLINE_ASSETS}
      >
        <Stack.Screen name={Screens.OFFLINE_ASSETS} component={AssetsScreen} />
        <Stack.Screen name={Screens.OFFLINE_ASSET} component={AssetScreen} />
      </Stack.Navigator>
      <SyncIndicator showSyncIcon />
    </>
  );
};
